<template>
  <div id="mapa-brasil" />
</template>

<script>
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';

  import MapboxConfig from '@/config/MapboxConfig';
  import mapbox from '@/config/Mapbox';
  import geojson from '@/components/general/graficos/data/brasil.json';

  const mapboxConfig = new MapboxConfig(mapbox.access_token, mapbox.style);

  export default {
    data() {
      return {
        map: null
      };
    },
    mounted() {
      this.configuraMapa(3);
      this.adicionaMapaBrasil();
      this.map.setView([-13.649319, -56.1236542]);
    },
    methods: {
      configuraMapa(zoom) {
        this.map = L.map('mapa-brasil', {
          layers: [mapboxConfig.getDefaultLayer()],
          zoom
        });
        L.control.layers(mapboxConfig.getBaseLayers()).addTo(this.map);
      },
      adicionaMapaBrasil() {
        L.geoJSON(geojson, {
          style: function () {
            return {
              color: '#f66448',
              weight: 1
            };
          }
        }).addTo(this.map);
      }
    }
  };
</script>

<style scoped>
  #mapa-brasil {
    min-height: 237px;
    max-height: 237px;
    z-index: 0;
  }
</style>
